import { Button, Stack, Typography } from '@mui/material'
import { Controller, Control } from 'react-hook-form'
import MinusSvg from '~/@ui/_sharedSvgs/FontAwesome/Minus.svg?react'
import PlusSvg from '~/@ui/_sharedSvgs/FontAwesome/Plus.svg?react'

type Props = {
  label: string
  name: string
  control: Control<any>
  className?: string
  min?: number
  max?: number
  step?: number
}

export const FormRow = ({
  label,
  name,
  control,
  className = '',
  min = 0,
  max = 99,
  step = 1,
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <Stack className={`flex-row justify-between items-center ${className}`}>
          <Typography className="text-3d font-medium text-zBlack200">
            {label}
          </Typography>

          <Stack className="flex-row w-[136px] justify-between items-center">
            <Button
              variant="contained"
              className="w-11 h-11 bg-zGrey200"
              onClick={() => {
                const newValue = Math.max(min, (value || 0) - step)
                onChange(newValue)
              }}
              disabled={value <= min}>
              <MinusSvg />
            </Button>

            <Typography className="text-3d font-bold text-zBlack200">
              {value || 0}
            </Typography>

            <Button
              variant="contained"
              className="w-11 h-11 bg-zGrey200"
              onClick={() => {
                const newValue = Math.min(max, (value || 0) + step)
                onChange(newValue)
              }}
              disabled={value >= max}>
              <PlusSvg />
            </Button>
          </Stack>
        </Stack>
      )}
    />
  )
}
